'use client';
import { FC } from 'react';

import { HEADER_FOOTER_TYPES } from '@/constants';
import Header from '../Header';
import Footer from '../Footer';
import { OverlayLoader } from '@/components/OverlayLoader';
import WhatsappFloater from '@/components/Whatsapp/Floater';
import { useHeaderContext } from '@/context/headerContext';
import LoginSignupFlow from '@/features/LoginSignup/components/LoginSignupFlow';
import { isWebview } from '@/utils/isWebview';

interface PropTypes {
  children: React.ReactNode;
}

const AppPageLayout: FC<PropTypes> = ({ children }) => {
  const { headerType, hideFooterOnly } = useHeaderContext();

  if (isWebview()) {
    return <>{children}</>;
  }

  return (
    <>
      <OverlayLoader />
      <Header type={headerType} />
      {headerType !== HEADER_FOOTER_TYPES.hidden && <WhatsappFloater />}
      {children}
      <LoginSignupFlow />
      <Footer type={hideFooterOnly ? HEADER_FOOTER_TYPES.hidden : headerType} />
    </>
  );
};

export default AppPageLayout;
